<template>
  <div :class="{ 'electron-search-result-wrap': isElectron }">
    <div class="filter-options">
      <div class="cont-area filter-item">
        <p class="option-name">内容分类</p>
        <ul class="option-list">
          <li
            @click="changeContentType(item.key)"
            :class="{ active: item.key === activeContentType }"
            class="option-item"
            v-for="item in contentClassify"
            :key="item.key"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div
        v-if="activeContentType === 'course'"
        class="cont-area filter-item course-filter"
      >
        <div class="left-wrap">
          <p class="option-name">课程分类</p>
          <ul class="option-list">
            <li
              @click="changeCourseType(item.key)"
              class="option-item"
              :class="{ active: item.key === activeCourseType }"
              v-for="item in courseClassify"
              :key="item.key"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <!-- 排序 -->
        <el-dropdown @command="handleMenuBehavior">
          <span class="el-dropdown-link">
            排序<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">推荐排序</el-dropdown-item>
            <el-dropdown-item command="1">价格从低到高</el-dropdown-item>
            <el-dropdown-item command="2">价格从高到低</el-dropdown-item>
            <el-dropdown-item command="3">报名人数从少到多</el-dropdown-item>
            <el-dropdown-item command="4">报名人数从多到少</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div
      class="cont-area page-cont"
      :class="{ 'course-tab-cont': activeContentType === 'course' }"
    >
      <!-- 全部 -->
      <div v-if="activeContentType === 'all'">
        <div v-if="courseNum">
          <div class="type-title-wrap">
            <p class="type-title">课程（{{ courseNum }}）</p>
            <button class="show-more" @click="changeContentType('course')">
              查看更多<i class="el-icon-arrow-right"></i>
            </button>
          </div>
          <div class="course-list">
            <CourseCard
              v-for="item in courseList.slice(0, 4)"
              :key="item.id"
              :courseInfo="item"
            />
          </div>
        </div>
        <div v-if="orgNum">
          <div class="type-title-wrap">
            <p class="type-title">机构（{{ orgNum }}）</p>
            <button class="show-more" @click="changeContentType('org')">
              查看更多<i class="el-icon-arrow-right"></i>
            </button>
          </div>
          <div class="org-list">
            <OrgCard
              v-for="item in orgList.slice(0, 3)"
              :key="item.org_id"
              :orgInfo="item"
            />
          </div>
        </div>
        <!-- 空状态 -->
        <el-empty
          v-if="!courseNum && !orgNum"
          description="暂无内容"
          :image="require('@/assets/img/live-list/empty.png')"
        ></el-empty>
      </div>
      <!-- 课程 -->
      <template v-else-if="activeContentType === 'course'">
        <div v-if="courseList.length" class="course-list">
          <CourseCard
            v-for="item in courseList"
            :key="item.id"
            :courseInfo="item"
          />
        </div>
        <!-- 空状态 -->
        <el-empty
          v-else
          description="暂无内容"
          :image="require('@/assets/img/live-list/empty.png')"
        ></el-empty>
      </template>
      <!-- 机构 -->
      <template v-else-if="activeContentType === 'org'">
        <div class="org-list" v-if="orgList.length">
          <OrgCard v-for="item in orgList" :key="item.org_id" :orgInfo="item" />
        </div>
        <!-- 空状态 -->
        <el-empty
          v-else
          description="暂无内容"
          :image="require('@/assets/img/live-list/empty.png')"
        ></el-empty>
      </template>
    </div>
  </div>
</template>

<script>
import { getOrganizationList } from "@saas/server-api/src/organization";
import OrgCard from "./components/OrgCard";
import CourseCard from "@saas/pages/src/home/components/CourseCard";
import { EventBus } from "@saas/components/src/utils/event-bus";
import { getCourseList } from "@saas/server-api/src/course";
import { getCourseState } from "@saas/server-api/src/course";
export default {
  data: function () {
    return {
      order_by: "",
      isElectron: window.isElectron,
      activeContentType: "all",
      activeCourseType: "all",
      contentClassify: [
        {
          key: "all",
          name: "全部",
        },
        {
          key: "course",
          name: "课程",
        },
        {
          key: "org",
          name: "机构",
        },
      ],
      courseClassify: [
        {
          key: "all",
          name: "全部",
        },
        {
          key: "free",
          name: "免费",
        },
        {
          key: "charge",
          name: "收费",
        },
      ],
      keyword: "",
      orgNum: 0,
      courseNum: 0,
      freeType: {
        all: "",
        free: 1,
        charge: 2,
      },
      courseList: [],
      orgList: [],
      orgPage: {
        page_no: 1,
        page_size: 24,
      },
      coursePage: {
        page_no: 1,
        page_size: 12,
      },
      noMoreOrg: false,
      noMoreCourse: false,
    };
  },
  mounted() {
    this.initData();
    this.$nextTick(() => {
      if (window.isElectron) {
        let elMain = document.getElementById("electron-main");
        if (!elMain) return;
        elMain.addEventListener("scroll", this.handleElScrollFn, true);
      } else {
        window.addEventListener("scroll", this.scrollFn, true); //监听页面滚动
      }
    });
    EventBus.$off("keyword");
    EventBus.$on("keyword", (msg) => {
      if (msg != this.keyword) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            keyword: msg,
          },
        });
        this.keyword = msg;
        this.changeContentType();
      }
    });
  },
  beforeDestroy() {
    if (window.isElectron) {
      let elMain = document.getElementById("electron-main");
      if (!elMain) return;
      elMain.removeEventListener("scroll", this.handleElScrollFn, true);
    } else {
      window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
    }
  },
  methods: {
    handleMenuBehavior(command) {
      this.coursePage = {
        page_no: 1,
        page_size: 12,
      };
      this.order_by = command;
      this.contScrollTop();
      this.apiGetCourseList();
    },
    scrollFn() {
      if (this.activeContentType === "all" || this.loading) return;
      false;
      let noMore =
        this.activeContentType === "course"
          ? this.noMoreCourse
          : this.noMoreOrg;
      if (noMore) return false;
      //获取网页的总高度
      var htmlHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      //clientHeight是网页在浏览器中的可视高度
      var clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      //scrollTop是浏览器滚动条的top位置
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      //判断到底部了
      if (scrollTop + clientHeight > htmlHeight - 100) {
        if (this.activeContentType === "course") {
          this.coursePage.page_no++;
          this.apiGetCourseList();
        } else {
          this.orgPage.page_no++;
          this.apiGetOrganizationList();
        }
      }
    },
    handleElScrollFn(event) {
      if (this.activeContentType === "all" || this.loading) return;
      let noMore =
        this.activeContentType === "course"
          ? this.noMoreCourse
          : this.noMoreOrg;
      if (noMore) return false;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        if (this.activeContentType === "course") {
          this.coursePage.page_no++;
          this.apiGetCourseList();
        } else {
          this.orgPage.page_no++;
          this.apiGetOrganizationList();
        }
      }
    },
    initData() {
      if (this.$route.query.keyword) {
        this.keyword = this.$route.query.keyword;
        this.apiGetCourseList("init");
        this.apiGetOrganizationList("init");
      }
    },
    apiGetCourseList(type) {
      this.loading = true;
      let params = {
        ...this.coursePage,
        org_id: "",
        course_name: this.keyword,
        fee_type: this.freeType[this.activeCourseType],
        order_by: Number(this.order_by) || "",
      };
      if (type === "init") {
        params = {
          ...params,
          page_no: 1,
          page_size: 4,
        };
      }
      getCourseList(params)
        .then((res) => {
          if (res.code === 1) {
            if (type === "init") {
              this.courseNum = res?.data?.total || 0;
              this.courseList = res.data?.list || [];
            } else {
              if (params.page_no === 1) {
                this.courseList = res?.data?.list || [];
              } else {
                this.courseList = this.courseList.concat(res?.data?.list || []);
              }
              if (this.courseList.length === res?.data?.total) {
                this.noMoreCourse = true;
              } else {
                this.noMoreCourse = false;
              }
            }
            if (res?.data?.list?.length) {
              // 获取课程状态
              let list = res.data.list;
              let courseIds = list.map((course) => course.id);
              getCourseState({
                course_id: courseIds.join(","),
              }).then((res) => {
                if (res.code === 1 && res.data?.length) {
                  let haveStatusIds = res.data.map((item) => item.course_id);
                  list.forEach((course, index) => {
                    if (haveStatusIds.includes(course.id)) {
                      let { trial_state, live_state } = res.data.find(
                        (element) => element.course_id === course.id
                      );
                      this.$set(course, "trial_state", trial_state);
                      this.$set(course, "live_state", live_state);
                    }
                  });
                }
              });
            }
          } else {
            this.$message.error(res.message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    apiGetOrganizationList(type) {
      let params = {
        org_name: this.keyword,
        ...this.orgPage,
      };
      if (type === "init") {
        params = {
          ...params,
          page_no: 1,
          page_size: 3,
        };
      }
      getOrganizationList(params).then((res) => {
        if (res.code === 1) {
          if (type === "init") {
            this.orgNum = res?.data?.total || 0;
            this.orgList = res?.data?.list || [];
          } else {
            if (params.page_no === 1) {
              this.orgList = res?.data?.list || [];
            } else {
              this.orgList = this.orgList.concat(res?.data?.list || []);
            }
            if (this.orgList.length === res?.data?.total) {
              this.noMoreOrg = true;
            } else {
              this.noMoreOrg = false;
            }
          }
        }
      });
    },
    contScrollTop() {
      if (window.isElectron) {
        let elMain = document.getElementById("electron-main");
        if (!elMain) return;
        elMain.scrollTop = 0;
      } else {
        window.scrollTo({
          top: 0,
          behavior: "instant",
        });
      }
    },
    changeContentType(key) {
      if (key === this.activeContentType) return false;
      this.contScrollTop();
      if (key) {
        this.activeContentType = key;
      } else {
        key = this.activeContentType;
      }
      if (key === "all") {
        this.apiGetCourseList("init");
        this.apiGetOrganizationList("init");
      } else if (key === "course") {
        this.coursePage = {
          page_no: 1,
          page_size: 12,
        };
        this.apiGetCourseList();
      } else {
        this.orgPage = {
          page_no: 1,
          page_size: 24,
        };
        this.apiGetOrganizationList();
      }
    },
    changeCourseType(key) {
      if (key === this.activeCourseType) return false;
      this.contScrollTop();
      this.activeCourseType = key;
      this.coursePage = {
        page_no: 1,
        page_size: 12,
      };
      this.apiGetCourseList();
    },
  },
  components: {
    CourseCard,
    OrgCard,
  },
};
</script>

<style lang="scss" scoped>
// 客户端
.electron-search-result-wrap {
  .cont-area {
    width: 980px;
    margin: 0 auto;
  }
  .filter-item {
    position: relative;
    left: -45px;
  }
  .org-list .org-card {
    margin-right: 25px;
  }
}
.page-cont {
  min-height: calc(100vh - #{$nav-bar-height} - #{$nav-footer-height});
  padding-top: 88px;
  &.course-tab-cont {
    padding-top: 136px;
  }
}
.cont-area {
  width: 1200px;
  margin: 0 auto;
}
.filter-options {
  position: fixed;
  background: #ffffff;
  padding-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  z-index: 9;
  .filter-item {
    display: flex;
    padding-bottom: 20px;
    align-items: center;
  }
  .course-filter {
    justify-content: space-between;
  }
  .left-wrap {
    display: flex;
    align-items: center;
  }
  .el-dropdown-link {
    font-size: 16px;
    color: #747573;
    line-height: 22px;
  }
  .option-name {
    font-weight: 600;
    font-size: 16px;
    color: #0d1400;
    line-height: 22px;
    margin-right: 30px;
  }
  .option-list {
    display: flex;
  }
  .option-item {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #515350;
    line-height: 1;
    padding: 0 9px;
    height: 28px;
    margin-right: 18px;
    cursor: pointer;
  }
  .active {
    color: #00c89d;
    background: #effff9;
    border-radius: 8px;
  }
}
.type-title-wrap {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  .type-title {
    font-weight: 600;
    font-size: 24px;
    color: #0d1400;
    line-height: 33px;
  }
  .show-more {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #575859;
    line-height: 22px;
    i {
      font-size: 14px;
      color: #82867c;
      font-weight: 600;
      line-height: 22px;
      margin-left: 4px;
      margin-top: 2px;
    }
  }
}

.org-list {
  display: flex;
  flex-wrap: wrap;
  .org-card {
    margin-right: 30px;
    margin-bottom: 24px;
  }
  .org-card:nth-child(3n) {
    margin-right: 0;
  }
}
.course-list {
  display: flex;
  flex-wrap: wrap;
}

::v-deep .el-empty {
  height: 500px;
}
</style>
